// Contact Page Content
import { FaWhatsapp, FaEnvelope, FaGlobe, FaMapMarkerAlt, FaClock, FaPhone } from 'react-icons/fa';

export const contactContent = {
  hero: {
    title: "نحن هنا لمساعدتك",
    subtitle: "تواصل معنا الآن",
    description: "سواء كان لديك سؤال، مشروع جديد، أو تحتاج استشارة - فريقنا جاهز للرد عليك"
  },

  contactMethods: {
    title: "تواصل معنا بالطريقة الأنسب لك",
    methods: [
      {
        id: 1,
        icon: FaWhatsapp,
        title: "واتساب (الأسرع)",
        value: "+20 109 631 2346",
        link: "https://wa.me/201096312346",
        description: "تواصل معنا مباشرة وسنرد خلال دقائق",
        isPrimary: true
      },
      {
        id: 2,
        icon: FaEnvelope,
        title: "البريد الإلكتروني",
        value: "contact@nomumarketing.com",
        link: "mailto:contact@nomumarketing.com",
        description: "راسلنا وسنرد خلال 24 ساعة",
        isPrimary: false
      },
      {
        id: 3,
        icon: FaGlobe,
        title: "الموقع الإلكتروني",
        value: "www.nomumarketing.com",
        link: "#",
        description: "تصفح خدماتنا وأعمالنا",
        isPrimary: false
      },
      {
        id: 4,
        icon: FaMapMarkerAlt,
        title: "الموقع",
        value: "",
        link: null,
        description: "العمل عن بُعد",
        isPrimary: false
      }
    ]
  },

  contactForm: {
    title: "أو املأ النموذج وسنتواصل معك",
    subtitle: "سنرد عليك في أقرب وقت",
    fields: [
      {
        name: "fullName",
        label: "الاسم الكامل",
        type: "text",
        placeholder: "أدخل اسمك الكامل",
        required: true
      },
      {
        name: "email",
        label: "البريد الإلكتروني",
        type: "email",
        placeholder: "example@email.com",
        required: true
      },
      {
        name: "phone",
        label: "رقم الجوال (واتساب)",
        type: "tel",
        placeholder: "+966 5X XXX XXXX",
        required: true
      },
      {
        name: "service",
        label: "الخدمة المطلوبة",
        type: "select",
        options: [
          { value: "", label: "اختر الخدمة" },
          { value: "web-design", label: "تصميم موقع" },
          { value: "social-media", label: "إدارة سوشيال ميديا" },
          { value: "paid-ads", label: "إعلانات ممولة" },
          { value: "consultation", label: "استشارة عامة" },
          { value: "other", label: "أخرى" }
        ],
        required: true
      },
      {
        name: "message",
        label: "تفاصيل المشروع",
        type: "textarea",
        placeholder: "أخبرنا عن احتياجاتك ومتطلبات مشروعك...",
        required: true,
        rows: 5
      },
      {
        name: "budget",
        label: "الميزانية المتوقعة (اختياري)",
        type: "select",
        options: [
          { value: "", label: "اختر الميزانية" },
          { value: "less-5k", label: "أقل من 5,000 ريال" },
          { value: "5k-10k", label: "5,000 - 10,000 ريال" },
          { value: "10k-20k", label: "10,000 - 20,000 ريال" },
          { value: "20k-50k", label: "20,000 - 50,000 ريال" },
          { value: "more-50k", label: "أكثر من 50,000 ريال" }
        ],
        required: false
      }
    ],
    submitButton: "إرسال الطلب",
    successMessage: "شكراً لتواصلك معنا! سنرد عليك في أقرب وقت.",
    errorMessage: "حدث خطأ، يرجى المحاولة مرة أخرى أو التواصل عبر واتساب."
  },

  workingHours: {
    title: "أوقات العمل",
    icon: FaClock,
    schedule: [
      {
        days: "السبت - الخميس",
        hours: "9:00 صباحاً - 6:00 مساءً",
        timezone: "بتوقيت السعودية"
      },
      {
        days: "الجمعة",
        hours: "مغلق",
        timezone: ""
      }
    ],
    note: "💬 خدمة واتساب متاحة على مدار 24 ساعة"
  },

  faq: {
    title: "أسئلة سريعة؟",
    items: [
      {
        id: 1,
        question: "كم المدة للرد على استفساري؟",
        answer: "نرد خلال ساعات عبر واتساب، و24 ساعة عبر الإيميل"
      },
      {
        id: 2,
        question: "هل الاستشارة الأولى مجانية؟",
        answer: "نعم، الاستشارة الأولى مجانية تماماً"
      },
      
      {
        id: 3,
        question: "كيف أحجز موعد؟",
        answer: "تواصل معنا عبر واتساب وسنحدد موعد يناسبك"
      },
      {
        id: 4,
        question: "هل توفرون عروض أسعار مجانية؟",
        answer: "نعم، نرسل لك عرض سعر مفصّل بعد فهم احتياجاتك"
      }
    ]
  },

  cta: {
    title: "مستعد للبدء؟",
    subtitle: "تواصل معنا الآن وابدأ رحلة النجاح الرقمي",
    buttonText: "تواصل عبر واتساب 💬"
  }
};
